<div class="container-narrow notranslate px-0"
     *ngIf="bookingFlowInfo.selectedTreatments.length">

  <ng-container [formGroup]="bookingStepsForm">
    <app-choose-treatments-and-employees (click)="onEditVisitSlotStep()"></app-choose-treatments-and-employees>
    <app-booking-stepper #bookingStepper>
      <cdk-step>
        <ng-container *ngIf="bookingStepper.selectedIndex === 0">
          <app-stepper [salonDetails]="bookingFlowInfo.salonDetails"></app-stepper>
          <app-choose-visit-slot (moveToTheNextStep)="moveToNextStep($event)"></app-choose-visit-slot>
        </ng-container>
      </cdk-step>
      <cdk-step>
        <ng-container *ngIf="bookingStepper.selectedIndex === 1">
          <div class="row bg-gray-100 text-secondary border-top border-bottom border-white py-3"
               *ngIf="bookingStepsForm.controls.visitSlot?.value.startDate">
            <div class="col-12 d-flex align-items-center justify-content-between">
              <div>
                {{ bookingStepsForm.controls.visitSlot.value.startDate | visitSlotDate:currentLang }}
              </div>
              <a class="fw-bolder text-end clickable"
                 (click)="onEditVisitSlotStep()"
                 [translate]="'BOOKING-PART.STEPS-SUMMARY.BUTTON-EDIT'"></a>
            </div>
          </div>
          <app-stepper [salonDetails]="bookingFlowInfo.salonDetails"></app-stepper>
          <app-booking-part-customer-data
                                          [salonDetails]="bookingFlowInfo.salonDetails"></app-booking-part-customer-data>
        </ng-container>
      </cdk-step>
    </app-booking-stepper>
  </ng-container>
</div>
